export default function MyWallet() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              My Wallet
            </div>
            <div className="page-sub" id="page-sub">
              Coin balance, top-up &amp; transaction history
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          {/* BALANCE HERO */}
          <div
            style={{
              background: "linear-gradient(135deg,#0F6E56 0%,#185FA5 100%)",
              borderRadius: "var(--radius-lg)",
              padding: "28px 32px",
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,0.7)",
                  textTransform: "uppercase",
                  letterSpacing: ".08em",
                  marginBottom: 6,
                }}
              >
                🪙 Coin Balance — Priya Sharma
              </div>
              <div
                style={{
                  fontSize: 42,
                  fontWeight: 800,
                  color: "#fff",
                  letterSpacing: "-1px",
                }}
              >
                850
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "rgba(255,255,255,0.7)",
                  marginTop: 4,
                }}
              >
                1 Coin = ₹1 &nbsp;·&nbsp; Last updated: Apr 18, 2025
              </div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                onclick="showPage('tn-payments',document.querySelector('[data-id=tn-payments]'))"
                style={{
                  background: "#fff",
                  color: "#0F6E56",
                  border: "none",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 22px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                + Add Funds
              </button>
              <button
                style={{
                  background: "rgba(255,255,255,0.15)",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: "var(--radius-md)",
                  padding: "10px 18px",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                📊 Statement
              </button>
            </div>
          </div>
          <div className="stat-grid" style={{ marginBottom: 20 }}>
            <div className="stat-card">
              <div className="stat-icon">💰</div>
              <div className="stat-label">Total Added</div>
              <div className="stat-value">₹5,000</div>
              <div className="stat-delta delta-up">All time</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📤</div>
              <div className="stat-label">Total Used</div>
              <div className="stat-value">₹4,150</div>
              <div className="stat-delta delta-neu">Rent payments</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📥</div>
              <div className="stat-label">Pending Requests</div>
              <div className="stat-value">₹500</div>
              <div className="stat-delta delta-neu">Awaiting approval</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Last Recharge</div>
              <div className="stat-value">₹2,000</div>
              <div className="stat-delta delta-up">Apr 10, 2025</div>
            </div>
          </div>
          <div className="two-col">
            <div className="card">
              <div className="card-title">Transaction History</div>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Credit</th>
                    <th>Debit</th>
                    <th>Balance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="sn-col">1</td>
                    <td>Apr 10</td>
                    <td>Wallet top-up (UPI)</td>
                    <td style={{ color: "var(--green)", fontWeight: 600 }}>
                      +2,000
                    </td>
                    <td>—</td>
                    <td>2,350</td>
                    <td>
                      <span className="badge badge-active">Approved</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">2</td>
                    <td>Apr 05</td>
                    <td>Rent payment — April 2025</td>
                    <td>—</td>
                    <td style={{ color: "var(--red)" }}>-1,500</td>
                    <td>350</td>
                    <td>
                      <span className="badge badge-info">Auto</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">3</td>
                    <td>Mar 15</td>
                    <td>Wallet top-up (Bank Transfer)</td>
                    <td style={{ color: "var(--green)", fontWeight: 600 }}>
                      +3,000
                    </td>
                    <td>—</td>
                    <td>1,850</td>
                    <td>
                      <span className="badge badge-active">Approved</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">4</td>
                    <td>Mar 05</td>
                    <td>Rent payment — March 2025</td>
                    <td>—</td>
                    <td style={{ color: "var(--red)" }}>-1,500</td>
                    <td>-1,150</td>
                    <td>
                      <span className="badge badge-info">Auto</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="sn-col">5</td>
                    <td>Feb 20</td>
                    <td>Wallet top-up (UPI)</td>
                    <td style={{ color: "var(--green)", fontWeight: 600 }}>
                      +650
                    </td>
                    <td>—</td>
                    <td>650</td>
                    <td>
                      <span className="badge badge-active">Approved</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card">
              <div className="card-title">My Recharge Requests</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    UPI · ₹500
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Apr 14, 2025 · UTR: UPI2025041400872
                  </div>
                </div>
                <span className="badge badge-pending">Pending</span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    Bank Transfer · ₹3,000
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Mar 15, 2025 · UTR: SBIN2025031501234
                  </div>
                </div>
                <span className="badge badge-active">Approved</span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0",
                }}
              >
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    UPI · ₹2,000
                  </div>
                  <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>
                    Apr 10, 2025 · UTR: UPI2025041000341
                  </div>
                </div>
                <span className="badge badge-active">Approved</span>
              </div>
              <button
                className="btn btn-sm btn-teal"
                style={{ marginTop: 10 }}
                onclick="showPage('tn-payments',document.querySelector('[data-id=tn-payments]'))"
              >
                + New Recharge Request
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
